<template>
  <GmapMap
    class="gmap"
    :center="{
                  lat: latitude,
                  lng: longitude,
                }"
    :zoom="14"
    map-type-id="terrain"
    style="height: 400px; min-width: 100%;"
  >
    <GmapMarker
      :position="{
                    lat: latitude,
                    lng: longitude,
                  }"
      :clickable="true"
      :draggable="true"
      @click="center = m.position"
    />
  </GmapMap>
</template>


<script>
export default {
  name: "GMap",
  props: {
    latitude: {
      type: Number,
      default: 0
    },
    longitude: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style>
.vue-map {
    border-radius: 14px;
}
</style>